import {Injectable, isDevMode} from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {Volunteerdata} from "./volunteerdata"
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {collection, getCountFromServer, getFirestore, query} from "firebase/firestore";

export interface VolunteerRequest{
  id:string,
  contact_number:number,
  email_number:string,
  emergency_number:string
  first_name:string
  last_name:string

}

@Injectable({
  providedIn: 'root'
})



export class VolunteerService {

  constructor(private mDatabase: AngularFireDatabase,
              private mFirestore:AngularFirestore) { }
  env= isDevMode()? environment.testMode :environment.productionMode
// addvolunteer(data:any){
//   let array = []
//   array.push(data)
//   //Method to set data in firestore database where folder name is testchild and file name is testdocument
//
// }

  addVolunteer(Volunteerdata:Volunteerdata) {
    this.mDatabase.list(this.env.volunteers).push(Volunteerdata)
  }


  getVolunteer() {
    return this.mDatabase.list(this.env.volunteers).snapshotChanges()
  }
  getRequestedVolunteer() {
    const volunteerRef = this.mFirestore.doc<any>(this.env.reqvolunteers)
    return volunteerRef.valueChanges()
  }

  getVolunteerList() {
    const volunteerRef = this.mFirestore.doc(this.env.reqvolunteers)
    return volunteerRef.snapshotChanges()
  }
  getVolunteersCount():Observable<number>{
    return this.mFirestore.collection('volunteer').valueChanges().pipe(
      map(docs => docs.length)
    )
  }

  //* Count-only variant using Firestore count() aggregation — avoids downloading full documents just to read .length
  getVolunteersCountFromServer(): Promise<number> {
    const q = query(collection(getFirestore(), 'volunteer'))
    return getCountFromServer(q).then(snap => snap.data().count)
  }

}
